import RealtyType from './RealtyType';
import Area from './Area';
import PriceTotal from './PriceTotal';
import PricePerMeter from './PricePerMeter';
import Contacts from './Contacts';
import ContactsHidden from './ContactsHidden';
import MoreProperty from './MoreProperty';
import Date from './Date';
import Floor from './Floor';
import Address from './Address';
import Photos from './Photos';
import Material from './Material';
import Seller from './Seller';
import BuildingSize from './BuildingSize';
import DealCondition from './DealCondition';

const AnnouncementPaperColumns = {
  RealtyType,
  Area,
  PriceTotal,
  PricePerMeter,
  Contacts,
  ContactsHidden,
  MoreProperty,
  Date,
  Floor,
  Address,
  Photos,
  Material,
  Seller,
  BuildingSize,
  DealCondition
};

module.exports = AnnouncementPaperColumns;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/index.js